module.exports = {
  platform: 'voice',
  name: 'Loop',
  node: 'loop',
  bg: '#FFFFFF',
  note: '',
  property: {
    variable: '',
    page: '',
    isLimit: false,
    limit: 10
  }
}
